import { createContext, useContext } from 'react';

import { CommunityAdminListType, CommunityType } from 'types/communities';

import { COMMUNITIES_ADMIN_PAGE_SIZE } from './constants';
import { CommunitiesFiltersType } from './types';

type CommunitiesContent = {
  loading: boolean;
  items: CommunityAdminListType[];
  totalItemsCount: number;
  filters: Partial<CommunitiesFiltersType>;
  manageContactsOpened: boolean;
  manageIncentivesOpened: boolean;
  setPage: (page: number) => void;
  setOrdering: (ordering: string) => void;
  setFilters: (filters: any) => void;
  refetch: () => void;
  setSelectedCommunityInfo: (communityInfo: CommunityType | undefined) => void;
  setManageContactsOpened: (open: boolean) => void;
  setManageIncentivesOpened: (open: boolean) => void;
};

export const CommunitiesContext = createContext<CommunitiesContent>({
  loading: false,
  items: [],
  totalItemsCount: 0,
  filters: {
    page: 1,
    pageSize: COMMUNITIES_ADMIN_PAGE_SIZE,
    search: '',
    company: [],
    companyStatus: [],
    auditTypes: [],
  },
  manageContactsOpened: false,
  manageIncentivesOpened: false,
  setPage: () => {
    // Do nothing
  },
  setOrdering: () => {
    // Do nothing
  },
  setFilters: () => {
    // Do nothing
  },
  refetch: () => {
    // Do nothing
  },
  setSelectedCommunityInfo: () => {
    // Do nothing
  },
  setManageContactsOpened: () => {
    // Do nothing
  },
  setManageIncentivesOpened: () => {
    // Do nothing
  },
});

export const useCommunitiesContext = () => useContext(CommunitiesContext);
